import React from "react";
import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />

        <h3> Keon Paul</h3>
        <p>Just a blank slate to start my journey of improvement</p>
      </header>
    </div>
  );
}

export default App;
